export default "<app-job-posting-form [type]=\"'HR'\"></app-job-posting-form>\r\n"